// Code generated by tygo. DO NOT EDIT.

//////////
// source: apikey.go

export interface TmpApiKey extends History {
  /**
   * NOTE: Hash
   */
  Key: string;
  ID: string;
  Type: string;
  Tenant: string;
  TTLUnix: number /* int64 */;
}
export interface TmpApiKeyClaims {
  StandardClaims: any /* jwt.StandardClaims */;
  id: string;
  type: string;
  tenant: string;
}
export type Type = string;
export const TypeLiff: Type = "liff";

//////////
// source: chat_connection.go

export interface ChatConnection {
  id: string;
  tenant: string;
  room_id: string;
  user: string;
  guest: string;
}
export const ChatConnectionTableName = "chat-connection";

//////////
// source: guest.go

export interface Guest extends History {
  id: string;
  tenant: string;
  type: GuestType;
  line_uid: string;
  name: string;
  avatar: string;
  status_message: string;
  language: string;
  blocked: GuestBlockState;
  notification_tags: string[];
  notification_enabled: boolean;
  last_notification_at?: string /* RFC3339 */;
}
export type GuestType = number /* int */;
export type GuestBlockState = number /* int */;
export const GuestWeb: GuestType = 0 + 1;
export const GuestLine: GuestType = 1 + 1;
export const GuestUnblocked: GuestBlockState = 0 + 1;
export const GuestBlocked: GuestBlockState = 1 + 1;
export const GuestTableName = "guest";

//////////
// source: line.go

export interface Line extends History {
  id: string;
  tenant: string;
  channel_id: string;
  channel_secret: string;
  long_term_token: string;
}
export const LineTableName = "line";

//////////
// source: message.go

export interface Message {
  id: string;
  room: string;
  guest: string;
  user: string;
  body: string;
  raw: string;
  created: string /* RFC3339 */;
  updated: string /* RFC3339 */;
}
export const MessageTableName = "message";

//////////
// source: model.go

export interface History {
  created: string /* RFC3339 */;
  updated: string /* RFC3339 */;
}

//////////
// source: notification_delivery.go

export interface NotificationDelivery {
  id: string;
  notification_id: string;
  guest_id: string;
  room_id: string;
  message_id: string;
  status: string;
  delivered_at?: string /* RFC3339 */;
  error?: string;
  created: string /* RFC3339 */;
  updated: string /* RFC3339 */;
}
export const NotificationDeliveryTableName = "notification_delivery";
export const DeliveryStatusProcessing = "processing";
export const DeliveryStatusDelivered = "delivered";
export const DeliveryStatusFailed = "failed";

//////////
// source: notification_history.go

export interface NotificationHistory extends History {
  id: string;
  tenant_id: string;
  type: string;
  title: string;
  message: string;
  tags: string[];
  target_count: number /* int */;
  delivered_count: number /* int */;
  failed_count: number /* int */;
  flex_message?: string;
  sent_at: string /* RFC3339 */;
  completed_at?: string /* RFC3339 */;
}
export const NotificationHistoryTableName = "notification_history";

//////////
// source: notification_tag.go

export interface NotificationTag extends History {
  id: string;
  tenant_id: string;
  name: string;
  description: string;
  color: string;
  is_active: boolean;
}
export const NotificationTagTableName = "notification_tag";

//////////
// source: room.go

export interface Room extends History {
  id: string;
  name: string;
  description: string;
  tenant: string;
  state: RoomState;
  guest: string;
  user: string;
}
export type RoomState = number /* int */;
export const RoomOpen: RoomState = 0 + 1;
export const RoomClose: RoomState = 1 + 1;
export const RoomTableName = "room";

//////////
// source: tenant.go

export type Plan = number /* int */;
export interface Tenant extends History {
  id: string;
  name: string;
  description: string;
  plan: Plan;
}
export const RootPlan: Plan = 0 + 1;
export const BetaFreePlan: Plan = 1 + 1;
export const TenantTableName = "tenant";

//////////
// source: user.go

export interface User extends History {
  id: string;
  email: string;
  name: string;
  tenant: string;
  role: Role;
}
export type Role = number /* int */;
export interface JwtClaims {
  id: string;
  role: Role;
  tenant: string;
  StandardClaims: any /* jwt.StandardClaims */;
}
export interface NewUserJwtClaims {
  user: string;
  tenant: string;
  role: Role;
  StandardClaims: any /* jwt.StandardClaims */;
}
export const AdminRole: Role = 0 + 1;
export const UserTableName = "user";
